import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import TrustMarquee from "@/components/landing/TrustMarquee";
import Features from "@/components/landing/Features";
import Manifesto from "@/components/landing/Manifesto";
import Audiences from "@/components/landing/Audiences";
import ApiSection from "@/components/landing/ApiSection";
import FinalCta from "@/components/landing/FinalCta";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div className="relative min-h-screen bg-[#05060a] text-white font-body antialiased" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <TrustMarquee />
        <Features />
        <Manifesto />
        <Audiences />
        <ApiSection />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}
